import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BrandStyleGuide from './pages/BrandStyleGuide';
import TemplateDownloads from './pages/TemplateDownloads';
import ComplianceChecker from './pages/ComplianceChecker';
import { Toaster } from './components/ui/sonner';
import './App.css';

export default function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<BrandStyleGuide />} />
          <Route path="/templates" element={<TemplateDownloads />} />
          <Route path="/compliance" element={<ComplianceChecker />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}
